import { useEffect } from "react";
import {
  Col,
  DropdownBox,
  FileUpload,
  InputField,
  Label,
  OutlineButton,
  PopupDialogbox,
  PrimaryButton,
  Row,
  SwitchToggle,
} from "client/CommonComponents";
import TagInput from "client/CommonComponents/Tags";
import "./AppOnboarding.scss";
import { appOnboardingInitialForm, appOnboardingInitialFormError } from "../../utils/constant";
import UserManageOperations from '../../../../../redux/UserManagement/operations'
import userManageSelectors from '../../../../../redux/UserManagement/selectors'
import { useDispatch, useSelector } from "react-redux";

type IProps = {
  applicationForm: any;
  handleChange: any;
  handleSubmit: any;
  applicationFormError: any;
  handleClickPopup: any;
  handleFailurePopup: any;
  setApplicationForm: any;
  selectedOption: any;
  handleClickCancel?: any;
  onChangeLogo?: any;
  setTagValue?: any;
  tagValue?: any;
  setApplicationFormError?: any;
  userProfileInfo?: any;
  onUploadClick?: any;
  Popupcontent?: any
};

const AppOnboarding = ({
  applicationForm,
  handleChange,
  handleSubmit,
  applicationFormError,
  setApplicationForm,
  selectedOption,
  handleClickCancel,
  onChangeLogo,
  setTagValue,
  tagValue,
  setApplicationFormError,
  userProfileInfo,
  onUploadClick,
  Popupcontent
}: IProps) => {
  const dispatch = useDispatch()
  const dispatchGetActiveCategory = UserManageOperations.dispatchGetActiveCategory(dispatch);
  const { applicationCheck, addApplicationVal, activeCategoryData, applicationById }: any = useSelector((state: any) => ({
    applicationCheck: userManageSelectors.checkApplication(state),
    addApplicationVal: state.UserManagement.addApplicationVal,
    activeCategoryData: state.UserManagement.activeCategoryData,
    applicationById: state.UserManagement.applicationById
  }))
  useEffect(() => {
    dispatchGetActiveCategory()
    if (!applicationById?.hasOwnProperty("id")) {
      setApplicationForm(appOnboardingInitialForm)
      setApplicationFormError(appOnboardingInitialFormError)
      setTagValue([])
    }
  }, []);

  return (
    <div className="app-grid-container">
      <Row>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label required data-attribute="AppOnboarding_Default_Label">App Name</Label>
          <InputField
            value={applicationForm.appName}
            onChange={handleChange}
            name="appName"
            disabled={selectedOption == "view"}
           data-attribute="AppOnboarding_appName_Input" />
          {applicationFormError?.appNameError ? (
            <span className="appArea-validation-msg">
              {applicationFormError?.appNameError}
            </span>
          ) : null}
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label required data-attribute="AppOnboarding_Default_Label_2">Tooltip Description</Label>
          <InputField
            value={applicationForm.tooltipdesc}
            onChange={handleChange}
            name="tooltipdesc"
            disabled={selectedOption == "view"}
           data-attribute="AppOnboarding_tooltipdesc_Input" />
          {applicationFormError?.tooltipdescError ? (
            <span className="appArea-validation-msg">
              {applicationFormError?.tooltipdescError}
            </span>
          ) : null}
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label data-attribute="AppOnboarding_Default_Label_3">Active</Label>
          <SwitchToggle
            name="isActive"
            checked={applicationForm.isActive}
            onChange={handleChange}
            disabled={selectedOption == "view"}
           data-attribute="AppOnboarding_isActive_SwitchToggle" />
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label required data-attribute="AppOnboarding_Default_Label_4">Category</Label>
          <DropdownBox
            options={activeCategoryData}
            onChange={handleChange}
            value={applicationForm?.category != "" ? applicationForm?.category?.key : null}
            name="category"
            placeholder="Select category"
            selectedKey={applicationForm?.category != "" ? applicationForm?.category?.key : null}
            disabled={selectedOption == "view"}
           data-attribute="AppOnboarding_category_Dropdown" />
          {applicationFormError?.categoryError ? (
            <span className="appArea-validation-msg">
              {applicationFormError?.categoryError}
            </span>
          ) : null}
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label data-attribute="AppOnboarding_Default_Label_5">App Logo</Label>
          <div className="app-onboarding-attachements">
            {
              !userProfileInfo.imagename ? <span className='nofile-chosen'>No file chosen</span> : <span className='file-name'>{applicationForm?.fileName}</span>
            }
            <FileUpload 
              file={applicationForm?.fileName} 
              disabled={selectedOption == "view"} 
              onClick = {onUploadClick} 
              onChange={onChangeLogo} 
               data-attribute="AppOnboarding_Default_FileUpload" />
          </div>
          {userProfileInfo?.profileImageError ? <span className="appArea-validation-msg">
            {userProfileInfo?.profileImageError}
          </span> : null}
          {applicationFormError?.logoImageSizeError ? (
            <span className="appArea-validation-msg">
              {applicationFormError?.logoImageSizeError}
            </span>
          ) : applicationFormError?.logoImageFormatError ? (<span className="appArea-validation-msg">
            {applicationFormError?.logoImageFormatError}
          </span>) : applicationFormError?.logoImageError ? (<span className="appArea-validation-msg">
            {applicationFormError?.logoImageError}
          </span>) : null}
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label data-attribute="AppOnboarding_Default_Label_6">Tags</Label>
          <TagInput value={(tagValue != undefined) ? (tagValue != '') ? tagValue : [] : []} onChange={setTagValue} name="tags" disabled={selectedOption == "view" ? true : false} />
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label data-attribute="AppOnboarding_Default_Label_7">Application URL</Label>
          <InputField
            name="appUrl"
            value={applicationForm.appUrl}
            onChange={handleChange}
            disabled={selectedOption == "view" ? true : false}
           data-attribute="AppOnboarding_appUrl_Input" />
        </Col>

        <Col className="pull-right">
          {selectedOption != "view" ?
            <PrimaryButton
              text="Save"
              className="pull-right "
              onClick={handleSubmit}
             data-attribute="AppOnboarding_Default_Button" /> : null}
          <OutlineButton text="Cancel" className="pull-right me-1" onClick={handleClickCancel}  data-attribute="AppOnboarding_Default_Button_2" />
        </Col>
      </Row>
      {addApplicationVal > 0 || applicationCheck || addApplicationVal == "error" ? (
        <PopupDialogbox
          hideDialog={!Popupcontent.isDialogVisible}
          onDismiss={() => Popupcontent?.popupOutlinebtnOnclick()}
          Popupcontent={Popupcontent}
          popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
          popupPrimarybtnOnclick={(
            item: any,
            actionby: string,
            value: any) => Popupcontent?.popupPrimarybtnOnclick(item,
              actionby,
              value)}
         data-attribute="AppOnboarding_Default_PopupDilalogBox" />
      ) : null}

    </div>

  );
};

export default AppOnboarding;
